import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFloatButton from "./components/WhatsAppFloatButton";
import MobileBookBar from "./components/MobileBookBar";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./admin/ProtectedRoute";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Marketplace from "./pages/Marketplace";
import ProductDetail from "./pages/ProductDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import SaurabhServices from "./pages/SaurabhServices";
import GauriServices from "./pages/GauriServices";
import ServiceDetail from "./pages/ServiceDetail";
import Gallery from "./pages/Gallery";
import Testimonials from "./pages/Testimonials";
import NotFound from "./pages/NotFound";

import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/Dashboard";
import BlogList from "./admin/BlogList";
import BlogForm from "./admin/BlogForm";
import ProductList from "./admin/ProductList";
import ProductForm from "./admin/ProductForm";
import MessagesList from "./admin/MessagesList";
import GalleryList from "./admin/GalleryList";
import GalleryForm from "./admin/GalleryForm";
import VideoList from "./admin/VideoList";
import VideoForm from "./admin/VideoForm";
import ServiceList from "./admin/ServiceList";
import ServiceForm from "./admin/ServiceForm";
import OtherServiceList from "./admin/OtherServiceList";
import OtherServiceForm from "./admin/OtherServiceForm";
import TestimonialList from "./admin/TestimonialList";
import TestimonialForm from "./admin/TestimonialForm";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="min-h-screen">{children}</main>
      <Footer />
      <WhatsAppFloatButton />
      <MobileBookBar />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Toaster position="top-center" toastOptions={{ duration: 4000 }} />
        <Routes>
          {/* Public Website */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/marketplace" element={<PublicLayout><Marketplace /></PublicLayout>} />
          <Route path="/marketplace/:slug" element={<PublicLayout><ProductDetail /></PublicLayout>} />
          <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
          <Route path="/blog/:slug" element={<PublicLayout><BlogDetail /></PublicLayout>} />
          <Route path="/pooja-services" element={<PublicLayout><SaurabhServices /></PublicLayout>} />
          <Route path="/pooja-services/:slug" element={<PublicLayout><ServiceDetail type="pooja" /></PublicLayout>} />
          <Route path="/astrology-palmistry-services" element={<PublicLayout><GauriServices /></PublicLayout>} />
          <Route path="/astrology-palmistry-services/:slug" element={<PublicLayout><ServiceDetail type="astrology" /></PublicLayout>} />
          <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
          <Route path="/testimonials" element={<PublicLayout><Testimonials /></PublicLayout>} />

          {/* Admin Panel */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="services" element={<ServiceList />} />
            <Route path="services/new" element={<ServiceForm />} />
            <Route path="services/edit/:id" element={<ServiceForm />} />
            <Route path="other-services" element={<OtherServiceList />} />
            <Route path="other-services/new" element={<OtherServiceForm />} />
            <Route path="other-services/edit/:id" element={<OtherServiceForm />} />
            <Route path="testimonials" element={<TestimonialList />} />
            <Route path="testimonials/new" element={<TestimonialForm />} />
            <Route path="testimonials/edit/:id" element={<TestimonialForm />} />
            <Route path="blogs" element={<BlogList />} />
            <Route path="blogs/new" element={<BlogForm />} />
            <Route path="blogs/edit/:id" element={<BlogForm />} />
            <Route path="products" element={<ProductList />} />
            <Route path="products/new" element={<ProductForm />} />
            <Route path="products/edit/:id" element={<ProductForm />} />
            <Route path="gallery" element={<GalleryList />} />
            <Route path="gallery/new" element={<GalleryForm />} />
            <Route path="gallery/edit/:id" element={<GalleryForm />} />
            <Route path="videos" element={<VideoList />} />
            <Route path="videos/new" element={<VideoForm />} />
            <Route path="videos/edit/:id" element={<VideoForm />} />
            <Route path="messages" element={<MessagesList />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
